import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import config from '../../../configs/config';
import CompassLogo from '../../../images/compass-logo.svg';
import { Row } from '../common-components';
import messages from './messages';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  position: sticky;
  top: 0;
  background-color: white;
`;

const NavLinks = styled(Row)`
  margin-left: 3rem;
  margin-right: 6rem;
  > a {
    margin-right: 1rem;
  }
`;

const Link = styled.a`
  color: grey;
  text-decoration: none;
  padding: 0.5rem;
  border-radius: 0.2rem;
  :hover {
    background-color: #d3d3d3;
  }
`;

const Button = styled.a`
  font-size: 16px;
  font-weight: 600;
  color: white;
  padding: 8px 16px;
  background-color: #80257b;
  border: none;
  cursor: pointer;
  text-decoration: none;
  border-radius: 4px;
  &: hover {
    background-color: #661e62;
  }
`;

const Navbar = () => {
  const { compassAppUrl, compassSiteUrl } = config;
  return (
    <Wrapper>
      <Row justify="flex-start" wrap>
        <img src={CompassLogo} alt="COMPASS" height={40} />
        <NavLinks>
          <Link href={compassSiteUrl} target="_blank">
            <FormattedMessage {...messages.products} />
          </Link>
          <Link href={compassAppUrl} target="_blank">
            <FormattedMessage {...messages.generalContractors} />
          </Link>
          <Link href={compassAppUrl} target="_blank">
            <FormattedMessage {...messages.subcontractors} />
          </Link>
          <Link href={compassSiteUrl} target="_blank">
            <FormattedMessage {...messages.resources} />
          </Link>
        </NavLinks>
        <Button href="mailto:demos@bespokemetrics.com?subject=compass demo request&body=I would like to schedule a demo!">
          <FormattedMessage {...messages.demo} />
        </Button>
      </Row>
    </Wrapper>
  );
};

export default Navbar;
